<mat-card appearance="outlined" class="card-widget" id="jobDesc_mat-card">
  <div class="float-right">
    <img
      src="assets/images/icons/default_icons/icon-close.png"
      alt="icon-close"
      [mat-dialog-close]="true"
      class="float-right"
      [ngStyle]="{ cursor: 'pointer' }"
    />
  </div>
  <mat-card-title class="grid" id="jobDesc_mat-card-title">
    <div id="jobDesc_mat-card-div">
      <h4 class="h4Header GreyDarkest text-1line" id="jobDesc_mat-card-h4">Job Description</h4>
    </div>
  </mat-card-title>
  <mat-card-subtitle
    id="jobDesc_mat-card-subtitle"
    class="mat-card-subtitle mainBodyTxt4 GreyLight text-1line"
  ></mat-card-subtitle>
</mat-card>
<mat-card appearance="outlined" id="jobDesc_mat-card2" *ngIf="dialogData">
  <mat-card-title class="grid" id="jobDesc_mat-card2-title">
    <mat-card-content id="jobDesc_mat-card-content">
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.requisitionId"
      >
        Requisition Id : {{ dialogData.requisitionId }}
      </div>
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.title"
      >
        Requisition Title : {{ dialogData.title }}
      </div>
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.recruiterId"
      >
        Recruiter Id : {{ dialogData.recruiterId }}
      </div>
      <div class="mainBodyTxt3 GreyDarkest text-1line padB8" id="jobDesc_mat-card-content-div1" *ngIf="dialogData.unit">
        Unit : {{ dialogData.unit }}
      </div>
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8 supportTeamText"
        id="jobDesc_mat-card-content-support"
        *ngIf="dialogData.supportTeam"
      >
        Support Team : {{ dialogData.supportTeam }}
      </div>
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.postingTitle != null"
      >
        Posting Title : {{ dialogData.postingTitle }}
      </div>
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.postingRole != null"
      >
        Posting Role : {{ dialogData.postingRole }}
      </div>
      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.postingDescription != null"
      >
        Description : {{ dialogData.postingDescription }}
      </div>

      <div
        class="mainBodyTxt3 GreyDarkest text-1line padB8"
        id="jobDesc_mat-card-content-div1"
        *ngIf="dialogData.technicalRequirement != null"
      >
        Technical Requirement : {{ dialogData.technicalRequirement }}
      </div>

      <div
        id="jobDesc_mat-card2-content-div6"
        class="mainBodyTxt2 mainBtn_normal h5Header marT12 marB2"
        *ngIf="dialogData.rolesResponsibilities != null"
      >
        Responsibilities:
      </div>
      <div id="jobDesc_mat-card2-content-div-res">
        <span id="jobDesc_mat-card2-content-span3" class="mat-card-subtitle mainBodyTxt4 GreyLight text-1line marB5">{{
          dialogData.rolesResponsibilities
        }}</span>
      </div>
      <div
        id="jobDesc_mat-card2-content-div6"
        class="mainBodyTxt2 mainBtn_normal h5Header marT12 marB2"
        *ngIf="dialogData.additionalResponsibility != null"
      >
        Additional Responsibility:
      </div>
      <div id="jobDesc_mat-card2-content-div-res">
        <span id="jobDesc_mat-card2-content-span3" class="mat-card-subtitle mainBodyTxt4 GreyLight text-1line marB5">{{
          dialogData.additionalResponsibility
        }}</span>
      </div>
    </mat-card-content>
  </mat-card-title>
</mat-card>
